// @ts-check
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';

const ScheduledAt = ({ referral, showScheduler, showReplacedBy }) => (
  <div className="secondaryData">
    {referral['active?'] && referral['booked?'] && (
      <div>
        {referral.scheduledAt} ({referral.appointmentStatusName})
      </div>
    )}
    {referral['active?'] &&
      (referral['appointmentCancelled?'] || referral['appointmentNoShow?']) && (
        <div>(Previous Appointment {referral.appointmentStatusName})</div>
      )}
    {referral['active?'] &&
      !referral['booked?'] &&
      referral['hasOrganization?'] &&
      !!showScheduler && (
        <div>
          <strong>
            <span className="fake-link" onClick={showScheduler}>
              Assign/Schedule
            </span>
          </strong>
        </div>
      )}
    <ReplacedOrTransferred showReplacedBy={showReplacedBy} referral={referral} />
  </div>
);

ScheduledAt.propTypes = {
  referral: PropTypes.object.isRequired,
  showScheduler: PropTypes.func,
  showReplacedBy: PropTypes.bool.isRequired,
};

ScheduledAt.defaultProps = {
  showReplacedBy: false,
};

const ReplacedOrTransferred = ({ showReplacedBy, referral }) => {
  if (referral['transferred?']) {
    return <div>Transferred to {referral.transferredToName}</div>;
  }
  if (showReplacedBy) {
    if (referral.replacedById) {
      return (
        <div>
          Replaced by{' '}
          <Link to={`/a/portal/referrals/${referral.replacedById}`}>a newer referral</Link>
        </div>
      );
    }
    if (referral['rejected?'] || referral['exhausted?'] || referral['withdrawn?']) {
      return <div>Not yet replaced</div>;
    }
  }
  return null;
};

export default ScheduledAt;
